import request from '@/utils/request'

// 查询采购发票列表
export function getExpendInvoiceList(query){
  return request({
    url: "/cw/cwExpenditureInvoice/getList",
    method: "get",
    params: query
  });
}
// 查询采购发票详情
export function getAllInvoiceHeadInfo(query){
  return request({
    url: "/cw/cwExpenditureInvoice/getId",
    method: "get",
    params: query
  });
}
// 新建
export function addCrmInvoice(data){
  return request({
    url: "/cw/cwExpenditureInvoice/add",
    method: "post",
    data: data
  });
}
// 修改
export function updateCrmInvoice(data){
  return request({
    url: "/cw/cwExpenditureInvoice/update",
    method: "put",
    data: data
  });
}
// 删除
export function deleteExpendInvoice(invoiceIds){
  return request({
    url: "/cw/cwExpenditureInvoice/delete/"+invoiceIds,
    method: "delete"
  });
}
// 开票
export function openInvoice(invoiceId){
  return request({
    url: "/cw/cwExpenditureInvoice/open",
    method: "put",
    params: invoiceId
  });
}
//查询所有入账
export function getEntryAllList(query){
  return request({
    url: "/cw/cwExpenditureInvoice/getExpenditureList",
    method: "get",
    params: query
  });
}
